import React, { useState } from 'react';
import { Box, Button, Text, TextArea } from 'grommet';
import { Add, Subtract } from 'grommet-icons'; // Icons for adding and removing questions
import './AddFitToFly.css'; // Import the external CSS

const AddFitToFly = () => {
  // State to manage questions
  const [questions, setQuestions] = useState([
    { id: 1, answer: '' }, // Initial question
  ]);

  // State to manage file upload
  const [file, setFile] = useState(null);

  // Handle file change
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle adding a new question
  const addQuestion = () => {
    setQuestions([
      ...questions,
      { id: questions.length + 1, answer: '' },
    ]);
  };

  // Handle removing a question
  const removeQuestion = (id) => {
    setQuestions(questions.filter((question) => question.id !== id));
  };

  // Handle answer change for each question
  const handleAnswerChange = (e, id) => {
    setQuestions(
      questions.map((question) =>
        question.id === id ? { ...question, answer: e.target.value } : question
      )
    );
  };

  return (
    <Box className="add-fit-to-fly-container">
      <Text className="add-fit-to-fly-header">Fit to Fly Form</Text>

      {/* File Upload */}
      <Box className="file-upload-container">
        <input
          type="file"
          onChange={handleFileChange}
          accept=".jpg,.png,.pdf"
          className="file-upload-input"
        />
      </Box>

      {/* Questions */}
      {questions.map((question, index) => (
        <Box key={question.id} className="question-container">
          <Text className="question-text">Question {index + 1}</Text>
          <Box direction="row" align="center" gap="small">
            <TextArea
              placeholder={`Answer to question ${index + 1}`}
              value={question.answer}
              onChange={(e) => handleAnswerChange(e, question.id)}
              className="question-textarea"
            />
            <Box direction="row" gap="small">
              {index === questions.length - 1 && (
                <Button
                  icon={<Add />}
                  onClick={addQuestion}
                  className="add-remove-button"
                />
              )}
              {questions.length > 1 && index === questions.length - 1 && (
                <Button
                  icon={<Subtract />}
                  onClick={() => removeQuestion(question.id)}
                  className="add-remove-button"
                />
              )}
            </Box>
          </Box>
        </Box>
      ))}

      {/* Submit Button */}
      <Button label="Submit" primary className="submit-button" />
    </Box>
  );
};

export default AddFitToFly;
